import TrackableRedirect from '@components/TrackingRedirect';

const ACast = () => {
  return <TrackableRedirect to="/ai-team-rating" />;
};

export default ACast;
